import { css, type CSSObject } from "@emotion/react";

import type { SizeUnit } from "../utils";

export const borderBlockStart = ({
  width,
  style,
  color,
  radius,
}: {
  width?: SizeUnit;
  style?: CSSObject["borderBlockStyle"];
  color?: CSSObject["borderBlockColor"];
  radius?: SizeUnit;
}) => {
  return css({
    borderBlockStartWidth: width,
    borderBlockStartStyle: style,
    borderBlockStartColor: color,
    ...(radius && {
      borderStartStartRadius: radius,
      borderStartEndRadius: radius,
    }),
  });
};

export const borderBlockEnd = ({
  width,
  style,
  color,
  radius,
}: {
  width?: SizeUnit;
  style?: CSSObject["borderBlockStyle"];
  color?: CSSObject["borderBlockColor"];
  radius?: SizeUnit;
}) => {
  return css({
    borderBlockEndWidth: width,
    borderBlockEndStyle: style,
    borderBlockEndColor: color,
    ...(radius && {
      borderEndStartRadius: radius,
      borderEndEndRadius: radius,
    }),
  });
};

export const borderInlineStart = ({
  width,
  style,
  color,
  radius,
}: {
  width?: SizeUnit;
  style?: CSSObject["borderBlockStyle"];
  color?: CSSObject["borderBlockColor"];
  radius?: SizeUnit;
}) => {
  return css({
    borderInlineStartWidth: width,
    borderInlineStartStyle: style,
    borderInlineStartColor: color,
    ...(radius && {
      borderStartStartRadius: radius,
      borderEndStartRadius: radius,
    }),
  });
};

export const borderInlineEnd = ({
  width,
  style,
  color,
  radius,
}: {
  width?: SizeUnit;
  style?: CSSObject["borderBlockStyle"];
  color?: CSSObject["borderBlockColor"];
  radius?: SizeUnit;
}) => {
  return css({
    borderInlineEndWidth: width,
    borderInlineEndStyle: style,
    borderInlineEndColor: color,
    ...(radius && {
      borderStartEndRadius: radius,
      borderEndEndRadius: radius,
    }),
  });
};

export const border = ({
  width,
  style,
  color,
  radius,
}: {
  width?: SizeUnit;
  style?: CSSObject["borderBlockStyle"];
  color?: CSSObject["borderBlockColor"];
  radius?: SizeUnit;
}) => {
  return css({
    ...(width && {
      borderBlockStartWidth: width,
      borderBlockEndWidth: width,
      borderInlineStartWidth: width,
      borderInlineEndWidth: width,
    }),
    ...(style && {
      borderBlockStartStyle: style,
      borderBlockEndStyle: style,
      borderInlineStartStyle: style,
      borderInlineEndStyle: style,
    }),
    ...(color && {
      borderBlockStartColor: color,
      borderBlockEndColor: color,
      borderInlineStartColor: color,
      borderInlineEndColor: color,
    }),
    ...(radius && {
      borderTopLeftRadius: radius,
      borderTopRightRadius: radius,
      borderBottomLeftRadius: radius,
      borderBottomRightRadius: radius,
    }),
  });
};
